/* eslint-disable */

/* global msCrypto, WorkerGlobalScope */
// NOTE:
// Don't use any DOM API here, this file is for react-native,
// web client app, and also it can be loaded inside the webworker.
// IT SHOILD BE STATELESS, To be able to restart web worker easily
// NOTE: was taken from 'uuid' module
var UUID = function () {
  /**
   * Convert array of 16 byte values to UUID string format of the form:
   * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
   */
  var byteToHex = [];

  for (var i = 0; i < 256; ++i) {
    byteToHex[i] = (i + 0x100).toString(16).substr(1);
  }

  function bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4

    return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
  }

  var createRandomValues = function () {
    // Unique ID creation requires a high quality random # generator.  In the
    // browser this is a little complicated due to unknown quality of Math.random()
    // and inconsistent support for the `crypto` API.  We do the best we can via
    // feature-detection
    // getRandomValues needs to be invoked in a context where "this" is a Crypto
    // implementation. Also, find the complete implementation of crypto on IE11.
    var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (getRandomValues) {
      // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
      var rnds8 = new Uint8Array(16);
      return function whatwgRNG() {
        getRandomValues(rnds8);
        return rnds8;
      };
    } else {
      // Math.random()-based (RNG)
      //
      // If all else fails, use Math.random().  It's fast, but is of unspecified
      // quality.
      var rnds = new Array(16);
      return function mathRNG() {
        for (var i = 0, r; i < 16; i++) {
          // eslint-disable-next-line curly
          if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
          rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }

        return rnds;
      };
    }
  }();

  return function UUID_() {
    var rnds = createRandomValues(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    return bytesToUuid(rnds);
  };
}();

var IT_IS_A_WEB_WORKER = typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
var KEYS_STR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function getEventProps(params, writeKey) {
  var uuid = UUID();
  var sentAt = new Date();
  return {
    sentAt: sentAt,
    timestamp: sentAt,
    context: {
      library: {
        name: params.context.library.name,
        version: params.context.library.version
      },
      page: {
        referrer: params.context.page.referrer,
        path: params.context.page.path,
        search: params.context.page.search,
        title: params.context.page.title,
        url: params.context.page.url,
        inIframe: params.context.page.inIframe
      },
      userAgent: params.context.userAgent
    },
    messageId: 'ajs-' + uuid.replace(/-/g, ''),
    event: undefined,
    properties: undefined,
    traits: undefined,
    writeKey: writeKey,
    anonymousId: params.anonymousId,
    userId: params.userId ? params.userId : undefined
  };
}

function identify(params) {
  var url = params.apiHost + '/i';
  var properties = getEventProps(params, params.apiKey);
  properties.type = 'identify';

  if (params.timestamp) {
    properties.timestamp = params.timestamp;
  }

  properties.traits = {
    name: params.user.name,
    email: params.user.email
  };
  var xhr = new XMLHttpRequest();
  xhr.open('POST', url, true);
  xhr.setRequestHeader('Content-Type', 'text/plain');
  xhr.send(JSON.stringify(properties));
}

function page(params) {
  var url = params.apiHost + '/p';
  var properties = getEventProps(params, params.apiKey);
  properties.type = 'page';

  if (params.timestamp) {
    properties.timestamp = params.timestamp;
  }

  properties.properties = {
    language: params.context.page.site_language,
    referrer: params.context.page.referrer,
    path: params.context.page.path,
    search: params.context.page.search,
    title: params.context.page.title,
    url: params.context.page.url,
    site_language: params.context.page.site_language
  };
  properties.site_language = params.context.page.site_language;
  var xhr = new XMLHttpRequest();
  xhr.open('POST', url, true);
  xhr.setRequestHeader('Content-Type', 'text/plain');
  xhr.send(JSON.stringify(properties));
}

function copyTypedArrayToRegularArray(typedArray, length) {
  var result = new Array(length);

  for (var i = 0; i < length; i++) {
    result[i] = typedArray[i];
  }

  return result;
}

function extractTransferableItems(properties) {
  if (properties.__bufferData) {
    var bufferData = properties.__bufferData;
    delete properties.__bufferData;

    try {
      bufferData.items.forEach(function (transferItem) {
        var value = undefined;

        switch (transferItem.type) {
          case 'Uint32Array':
            {
              var arr = new Uint32Array(transferItem.buffer);
              value = copyTypedArrayToRegularArray(arr, transferItem.bufferLength);
            }
            break;

          case 'Int32Array':
            {
              var arr = new Int32Array(transferItem.buffer);
              value = copyTypedArrayToRegularArray(arr, transferItem.bufferLength);
            }
            break;

          case 'Float32Array':
            {
              var arr = new Float32Array(transferItem.buffer);
              value = copyTypedArrayToRegularArray(arr, transferItem.bufferLength);
            }
            break;

          default:
            {
              value = undefined;
              console.error('Transferable type is not supported: ', transferItem.type);
            }
            break;
        }

        if (value) {
          properties[transferItem.name] = value;
        }
      });
    } catch (e) {
      console.error('Transferable error', e);
    }
  }
}

function track(params) {
  var url = params.apiHost + '/t';
  var properties = buildTrackProperties(params, params.apiKey);
  var xhr = new XMLHttpRequest();
  xhr.open('POST', url, true);
  xhr.setRequestHeader('Content-Type', 'text/plain');
  xhr.send(JSON.stringify(properties));
}

function buildTrackProperties(track, apiKey) {
  var properties = getEventProps(track, apiKey);
  properties.type = 'track';
  properties.event = track.event;

  if (track.timestamp) {
    properties.timestamp = track.timestamp;
  }

  extractTransferableItems(track.properties);
  properties.properties = track.properties;
  return properties;
}

function trackBatch(params) {
  var url = params.apiHost + '/batch';
  var batch = [];
  params.tracks.forEach(function (track) {
    var properties = buildTrackProperties(track, undefined);
    batch.push(properties);
  });
  var body = {
    batch: batch,
    writeKey: params.apiKey
  }; // TODO: may be should be not here and should be passed from above? useless base64 encoding =\

  var apiKeyBase64 = stringToBase64(params.apiKey + ':');
  var xhr = new XMLHttpRequest();
  xhr.open('POST', url, true);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.setRequestHeader('Authorization', 'Basic ' + apiKeyBase64);
  xhr.send(JSON.stringify(body));
} // NOTE: object wrapper to be able to mock methods in tests


var METHODS_CONTAINER = {
  identify: identify,
  track: track,
  trackBatch: trackBatch,
  page: page
};

function processWorkerMessage(data) {
  var event = data.event;
  var payload = data.payload;

  switch (event) {
    case 'identify':
      {
        METHODS_CONTAINER.identify(payload);
      }
      break;

    case 'track':
      {
        METHODS_CONTAINER.track(payload);
      }
      break;

    case 'trackBatch':
      {
        METHODS_CONTAINER.trackBatch(payload);
      }
      break;

    case 'page':
      {
        METHODS_CONTAINER.page(payload);
      }
      break;

    default:
      {
        console.error('Unknown event', data.event, data);
      }
  }
}

if (IT_IS_A_WEB_WORKER) {
  addEventListener('message', function (event) {
    var data = event.data;
    processWorkerMessage(data);
  });
  postMessage('ready');
} else {
  module.exports.UUID = UUID;
  module.exports.identify = identify;
  module.exports.track = track;
  module.exports.trackBatch = trackBatch;
  module.exports.page = page; // NOTE: for tests only

  module.exports.__stringToBase64 = stringToBase64;
  module.exports.__processWorkerMessage = processWorkerMessage;
  module.exports.__METHODS_CONTAINER = METHODS_CONTAINER;
} // NOTE: convert to bae64 was taken from `analytics.js` module


function stringToBase64(input) {
  var output = '';
  var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  var i = 0;
  input = utf8Encode(input);

  while (i < input.length) {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);
    enc1 = chr1 >> 2;
    enc2 = (chr1 & 3) << 4 | chr2 >> 4;
    enc3 = (chr2 & 15) << 2 | chr3 >> 6;
    enc4 = chr3 & 63;

    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }

    output = output + KEYS_STR.charAt(enc1) + KEYS_STR.charAt(enc2) + KEYS_STR.charAt(enc3) + KEYS_STR.charAt(enc4);
  }

  return output;
}

function utf8Encode(string) {
  string = string.replace(/\r\n/g, '\n');
  var utftext = '';

  for (var n = 0; n < string.length; n++) {
    var c = string.charCodeAt(n);

    if (c < 128) {
      utftext += String.fromCharCode(c);
    } else if (c > 127 && c < 2048) {
      utftext += String.fromCharCode(c >> 6 | 192);
      utftext += String.fromCharCode(c & 63 | 128);
    } else {
      utftext += String.fromCharCode(c >> 12 | 224);
      utftext += String.fromCharCode(c >> 6 & 63 | 128);
      utftext += String.fromCharCode(c & 63 | 128);
    }
  }

  return utftext;
}